import React, { Component, createRef } from "react";
import styles from "./Popup.module.scss";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { withRouter } from "react-router-dom";
import copy from "../../assets/copy/copy.json"
import { TimeInput, DateInput, Day, Week } from "@idui/react-date-components";
import { format, parse } from "date-fns";
import Button from '../UI/Button/Button';
import RepeatModal from "./RepeatModal";
import colors from "../../assets/idui_colours/colors.json"
import colorsdark from "../../assets/idui_colours/colorsdark.json"
import moment from "moment";
import Icon from "../../components/UI/Icon/Icon";
import { onCalendarIconClick } from "../../utils/SharedUtils";
import { Checkbox, Dropdown, DropdownDivider, DropdownItem, DropdownMenu, Radio } from 'semantic-ui-react';
import PagingGroupMultiSelectDropdown from "./PagingGroupMultiSelectDropdown";
import mdtoast from "@dmuy/toast";

var classNames = require("classnames");

class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      showPagingGroupModal: false,
      availabilityColour: null,
      availabilityTypes: "Available",
      timeFrom: moment().format("HH:00"),
      timeTo: moment().add(1, 'hour').format("HH:00"),
      pagingGroup: props.selectedGroups,
      userAgency: props.selectedAgency || props.defaultAgency,
      date: format(new Date(), "dd/MM/yyyy"),
      dateFrom: format(new Date(), "dd/MM/yyyy"),
      dateTo: null,
      colors: colors,
      selectedAvailabilityTypes: [],
      seriesType: null,
      daysOfWeek: null,
      dateOfMonth: null,
      repeatCount: null
    };
    this.repeatPayload = {
      dateFrom: null,
      dateTo: null,
      seriesType: null,
      daysOfWeek: null,
      dateOfMonth: null,
      repeatCount: null
    }
    this.availabilityTypes = null
    this.observer = null;
    this.minScreenHeightForPopup = 450;
  }
  toastie = (message = "Hello world!", type = "info", time = 5000) => {
    mdtoast(message, {
      duration: time,
      type: type,
      interaction: false,
    });
  };
  dateInputWeekRender = () => {
    return (weekDays) => (
      <Week>
        {["Su", "M", "Tu", "W", "Th", "F", "Sa"].map((item) => (
          <Day key={item}>{item}</Day>
        ))}
      </Week>
    );
  };

  availabilityColourUpdated = (colour) => {
    this.setState({
      availabilityColour: colour,
    })
  }

  togglePagingGroupOptions = () => {
    this.setState({ showPagingGroupModal: !this.state.showPagingGroupModal })
  }

  toggleRepeatOptions = () => {
    this.setState({ showRepeatModal: !this.state.showRepeatModal })
  }

  onApplyClick = () => {
    const allPagingGroups = this.props.pagingGroups[this.state.userAgency]?.map((e) => e.key.toString())
    let date;
    let dateTo;
    try {
      date = format(parse(this.state.date, 'dd/MM/yy', new Date()), 'yyyy-MM-dd');
      dateTo = this.state.dateTo ? format(parse(this.state.dateTo, 'dd/MM/yy', new Date()), 'yyyy-MM-dd') : null;
    } catch (error) {
      date = format(parse(this.state.date, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
      dateTo = this.state.dateTo ? format(parse(this.state.dateTo, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd') : null;
    }
    if (this.state.pagingGroup) {
      const pagingGroups = Object.keys(this.state.pagingGroup).filter(e => this.state.pagingGroup[e])
      if (pagingGroups.length > 0) {
        if (this.state.selectedAvailabilityTypes.length > 0) {
          const selectedPagingGroups = Object.keys(this.state.pagingGroup).filter(e => this.state.pagingGroup[e])
          const pagingGroups = Object.keys(this.state.pagingGroup).filter(e => this.state.pagingGroup[e])
          const payload = {
            pagingGroups,
            availabilityTypes: this.state.selectedAvailabilityTypes,
            date,
            timeFrom: this.state.timeFrom,
            timeTo: this.state.timeTo,
            dateTo,
            daysOfWeek: this.state.daysOfWeek,
            seriesType: this.state.seriesType,
            dateOfMonth: this.state.dateOfMonth,
            repeatCount: this.state.repeatCount,
            userAgency: this.state.userAgency
          }
          this.props.onApplyClick(payload)
          this.props.onClose()
        }
        else {
          this.toastie("Please select availability type!", "error");
        }
      }
      else {
        this.toastie("Please select a paging group!", "error");
      }
    }
    else {
      this.toastie("Please select a paging group!", "error");
    }
  }

  setRepeatPayload = (repeatPayload) => {
    this.setState({
      date: repeatPayload.dateFrom,
      dateFrom: repeatPayload.dateFrom,
      dateTo: repeatPayload.dateTo,
      seriesType: repeatPayload.seriesType,
      daysOfWeek: repeatPayload.daysOfWeek,
      dateOfMonth: repeatPayload.dateOfMonth,
      repeatCount: repeatPayload.repeatCount
    })
  }

  repeatButtonText = (seriesType) => {
    // check in RepeatModal if it's custom weekly, weekends or weekdays
    if (seriesType) {
      return seriesType;
    }
    return "Does not repeat"
  }
  setupMutationObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.props.currentHeight < this.minScreenHeightForPopup) {
      const callback = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(node => {
              if (node.parentNode === document.body && !this.state.showRepeatModal) {
                const firstChildDiv = node.firstElementChild;
                if (firstChildDiv && firstChildDiv.tagName.toLowerCase() === 'div') {
                  firstChildDiv.style.maxHeight = '11.5rem';
                }
                node.style.top = '3%';
                node.style.position = 'absolute';
                // removing the arrow from the popup
                const uniqueId = `node-${Math.random().toString(36).substr(2, 9)}`;
                node.setAttribute('data-unique-id', uniqueId);
                const style = document.createElement('style');
                style.innerHTML = `[data-unique-id="${uniqueId}"]::before { bottom: 0; }`;
                document.head.appendChild(style);
              }
            });
            //hide the trigger for potential future use, it's triggered when a node is removed
            /* mutation.removedNodes.forEach(node => {
              if (node.parentNode === null && mutation.target === document.body) {
                console.log('A direct child node has been removed.');
              }
            }); */
          }
        }
      };

      this.observer = new MutationObserver(callback);
      this.observer.observe(document.body, { childList: true });
    }
  }
  componentDidMount() {
    const theme = window.localStorage.getItem("displayPreference");
    if (theme === "dark") {
      this.setState({ colors: colorsdark });
    } else {
      this.setState({ colors: colors }); // Default colors
    }
    if (!this.state.showRepeatModal) {
      this.setupMutationObserver();
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.currentHeight !== this.props.currentHeight) {
      this.setupMutationObserver();
    }
  }

  componentWillUnmount() {
    this.setState({ showPopup: false });
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  renderDropdownItem = (option) => {
    return (
      <div className={`${styles['dualAvailabilityDropdownItem']} ${option.text}`}>
        {option.text}
      </div>
    );
  };
  handleDropdownChange = (e, { value }) => {
    e.preventDefault();
    const newVal = value[value.length - 1];
    if (!newVal) {
      this.setState((prevState) => ({ selectedAvailabilityTypes: value }));
      return;
    }
    if (newVal == "Unavailable") {
      this.setState({ selectedAvailabilityTypes: [newVal] });
      return;
    }
    else {
      if (this.state.selectedAvailabilityTypes.includes("Unavailable")) {
        this.setState((prevState) => ({ selectedAvailabilityTypes: [newVal] }));
        return;
      }
      if (newVal === "Emergency") {
        if (this.state.selectedAvailabilityTypes.includes("Available")) {
          this.setState((prevState) => ({ selectedAvailabilityTypes: ["Emergency"] }));
          return;
        }
      }
      else if (newVal === "Available") {
        if (this.state.selectedAvailabilityTypes.includes("Emergency")) {
          this.setState((prevState) => ({ selectedAvailabilityTypes: ["Available"] }));
          return;
        }
      }
    }
    this.setState((prevState) => ({ selectedAvailabilityTypes: value }));
    return;
  }
  handleDisabledDropdown = (value) => {
    const { selectedAvailabilityTypes, userAgency } = this.state;
    if (selectedAvailabilityTypes.includes(value)) {
      return true;
    }
    if (value === "Unavailable") {
      return false;
    }
    if (userAgency === "SES") {
      if (value === "Emergency") {
        if (selectedAvailabilityTypes.includes("Available")) {
          return true;
        }
        return false;
      }
      else if (value === "Available") {
        if (selectedAvailabilityTypes.includes("Emergency")) {
          return true;
        }
        return false;
      }
      else if (value === "Other") {
        return false;
      }
    }
    return false;
  }

  handlePagingGroupSelect = (groups) => {
    this.setState({ pagingGroup: groups })
  }

  render() {
    const { daysOfWeek, seriesType, dateOfMonth, repeatCount } = this.state;
    if (this.props.isVisible) {
      document.body.classList.add("popup-mode");
    } else {
      document.body.classList.remove("popup-mode");
    }

    let CloseAlertControls = classNames(
      "tileBg3 " + styles.closeAlertControls,
      this.props.className,
      {
        [styles.visible]: this.props.isVisible,
      },
      styles.addAvailabilityShortformContainer
    );

    let DarkMask = classNames(styles.darkMask, this.props.className, {
      [styles.visible]: this.props.isVisible,
    });

    const agencyAvailabilityTypes = copy.myAvailabilityScreen.agencyAvailabilityTypes;
    let emergencyLevels = agencyAvailabilityTypes[this.state.userAgency];
    const pagingGroups = this.props.pagingGroups[this.state.userAgency]?.map((e) => { return { key: e.text, value: e.key } })

    const renderLabel = (label) => ({
      content: `${label.text} `,
      className: `dualAvailabilityDropdownLabel ${label.text}`,
    })
    const typeOptions = emergencyLevels.map((e) => ({
      key: e,
      text: e,
      value: e,
      className: e,
      content: (e === 'Unavailable' || this.handleDisabledDropdown(e)) ?
        <Radio checked={this.state.selectedAvailabilityTypes.includes(e)} label={e} value={e} /> :
        <Checkbox checked={this.state.selectedAvailabilityTypes.includes(e)} label={e} value={e} />,
    }));
    let setPagingGroupText = "Set Paging Group"
    if (this.state.pagingGroup !== null) {
      let selectedPagingGroups = Object.keys(this.state.pagingGroup).filter(e => this.state.pagingGroup[e])
      setPagingGroupText = `${selectedPagingGroups.length} selected`
    }
    return (
      <Wrapper>
        <div>
          {this.state.showRepeatModal && <RepeatModal
            isVisible={this.state.showRepeatModal}
            onClose={() => this.setState({ showRepeatModal: false })}
            onSave={this.setRepeatPayload}
            dateFrom={this.state.date}
            dateTo={this.state.dateTo}
            daysOfWeek={daysOfWeek}
            seriesType={seriesType}
            dateOfMonth={dateOfMonth}
            repeatCount={repeatCount}
          />}
          <div style={{ display: this.state.showRepeatModal ? "none" : "unset" }} className={CloseAlertControls + " " + styles.shortForm}>
            <div className={styles.contents}>
              <div className={styles.spanButtons}>
                <div className={styles.headingText}>
                  <span>
                    {copy.myAvailabilityScreen.myAvailability.addAvailabilityForm.title}
                  </span>
                </div>
                <button
                  className="closeAlertControls__btn -close"
                  onClick={this.props.onClose}
                ></button>
              </div>
              <div className={styles.section}>

                <span className={styles.subtitleText}>
                  {copy.myAvailabilityScreen.myAvailability.addAvailabilityForm.description}
                </span>
              </div>
              <div className={styles.section}>
                <div className={styles.adaptableContainer}>
                  <div className={styles.groupedRow + " " + `dropDownClass`}>
                    <label htmlFor="userAgency">{copy.myAvailabilityScreen.myAvailability.addAvailabilityForm.userAgency}</label>
                    <Dropdown
                      compact
                      floating
                      defaultValue={this.state.userAgency}
                      text={this.state.userAgency}
                      placeholder={copy.myAvailabilityScreen.myAvailability.setAgency}
                      icon={<Icon icon="icon_arrowDownSmall" name="arrowIcon" />}
                      onChange={(e) => this.setState({ userAgency: e.target.value, pagingGroups: null })}
                    >
                      <DropdownMenu className="tileBg3">
                        {this.props.userAgencies.map((e) => {
                          return (
                            <DropdownItem key={e} className={styles.listItem}>
                              <Radio
                                checked={this.state.userAgency === e}
                                label={e}
                                value={e}
                                onChange={() => this.setState({ userAgency: e, pagingGroups: null })}
                              />
                            </DropdownItem>
                          )
                        })}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <div className={styles.groupedRow + " " + `dropDownClass`}>
                    <label htmlFor="pagingGroup">{copy.myAvailabilityScreen.myAvailability.addAvailabilityForm.pagingGroup}</label>
                    <PagingGroupMultiSelectDropdown
                      dropdownText={setPagingGroupText}
                      pagingGroups={pagingGroups}
                      selectedPagingGroups={this.state.pagingGroup}
                      handlePagingGroupSelect={this.handlePagingGroupSelect}
                      selectedAgency={this.state.userAgency}
                    />
                  </div>
                </div>
                <div className={styles.row + " " + ` dualAvailabilityDropdownClass`}>
                  <label htmlFor="availabilityType">{copy.myAvailabilityScreen.myAvailability.addAvailabilityForm.availabilityType}</label>
                  <Dropdown
                    className={(this.state.selectedAvailabilityTypes.length > 0 ? 'LabelsActive availabilityDropdown' : 'availabilityDropdown')}
                    value={this.state.selectedAvailabilityTypes}
                    options={typeOptions}
                    multiple
                    selection
                    placeholder='Set availability'
                    renderLabel={renderLabel}
                    onChange={this.handleDropdownChange}
                    closeOnChange={false}
                    icon={<Icon icon="icon_arrowDownSmall" name="arrowIcon" />}
                  />

                </div>
                <div className={styles.adaptableContainer + " " + styles.availabilityForm}>
                  <div className={styles.groupedRow}>
                    <label>{copy.myAvailabilityScreen.myAvailability.addAvailabilityForm.dateOfAvailability}</label>
                    <div onClick={() => onCalendarIconClick("addFormDateInputField")}>
                      <DateInput
                        readOnly={true}
                        isDateDisabled={(date) => date < new Date().setHours(0, 0, 0, 0)}
                        outputFormat="DD/MM/YY"
                        id="addFormDateInputField"
                        className="availabilityInputStyle repeatDateSelect"
                        style={{ width: "90px", textAlign: "center" }}
                        renderWeek={this.dateInputWeekRender()}
                        onChange={(newDate) => this.setState({ date: format(parse(newDate, 'dd/MM/yy', new Date()), 'dd/MM/yyyy') })}
                        isClearable={false}
                        value={format(parse(this.state.date, 'dd/MM/yyyy', new Date()), 'dd/MM/yy')}
                        required
                        colors={this.state.colors}
                        rightAddon={<Icon
                          icon="icon_minicalIcon"
                        />
                        }
                      />
                    </div>
                  </div>
                  <div className={styles.groupedRow}>
                    <label>Time:</label>
                    <div onClick={() => onCalendarIconClick("addStartTimeInputField")}>
                      <TimeInput
                        readOnly={true}
                        id="addStartTimeInputField"
                        rightAddon={<Icon
                          icon="icon_arrowDownSmall"
                        />
                        }
                        className="repeatSelectStyle timeInputStyle"
                        style={{ width: "65px", textAlign: "center" }}
                        isClearable={false}
                        value={this.state.timeFrom}
                        onChange={(newTime) => this.setState({ timeFrom: newTime })}
                        timeSlot={30}
                        required
                        colors={this.state.colors}
                      />
                    </div>
                    <div style={{ "padding": "5px" }}>→</div>
                    <div onClick={() => onCalendarIconClick("addEndTimeInputField")}>
                      <TimeInput
                        readOnly={true}
                        leftAddon={null}
                        id="addEndTimeInputField"
                        rightAddon={<Icon
                          icon="icon_arrowDownSmall"
                          />
                        }
                        className="repeatSelectStyle timeInputStyle"
                        style={{ width: "65px", textAlign: "center" }}
                        value={this.state.timeTo}
                        onChange={(newTime) => this.setState({ timeTo: newTime })}
                        isClearable={false}
                        timeSlot={30}
                        required
                        colors={this.state.colors}
                      />
                    </div>

                  </div>
                  <div className={styles.groupedRow}>
                    <label>Repeat:</label>
                    <Button
                      buttonClick={this.toggleRepeatOptions}
                      style={{ "gap": "10px", "padding": "0px 10px", "width": "auto" }}
                      styles=" repeatSelectStyle"
                      variant=''
                      content={
                        <>
                          {this.repeatButtonText(this.state.seriesType)}
                          <Icon icon="icon_arrowDownSmall" />
                        </>
                      }
                    />
                  </div>

                </div>

              </div>
              <div className={styles.row + " " + styles.footerButtonContainer}>
                <Button
                  style={{ width: "auto", "marginLeft": 0, height: "30px" }}
                  buttonClick={this.props.onClose}
                  content="Cancel"
                  styles="footerButton"
                  variant=""
                >
                </Button>
                <Button
                  buttonClick={this.onApplyClick}
                  style={{ width: "auto", "marginLeft": 0, height: "30px" }}
                  content="Apply"
                  styles="footerButton saveBtnStyle"
                  variant=""
                >
                </Button>
              </div>
            </div>
          </div>
          <div className={DarkMask} />
        </div>
      </Wrapper>
    );
  }
}

export default withRouter(Popup);
